import React, { useState } from "react";

import { motion } from "framer-motion";
import { Tilt } from "react-tilt";

import ProjectCard from "../components/ProjectCard";

import backwardArrow from "../assets/backwardArrow.svg";
import forwardArrow from "../assets/forwardArrow.svg";

import projectsData from "../exports/Projects";

function Projects() {
  const fadeInParams = {
    direction: "right",
    type: "spring",
    delay: 0 * 0.5,
    duration: 0.75,
  };
  // Determine how many cards to show based on screen size
  let cardsToShow;
  if (window.innerWidth >= 1024) {
    // Screen width greater than 1024px (typical tablet size)
    cardsToShow = 4;
  } else if (window.innerWidth < 1024 && window.innerWidth >= 768) {
    // Screen width between 768px and 1024px (typical tablet size)
    cardsToShow = 3;
  } else {
    // Screen width less than or equal to 768px (typical mobile size)
    cardsToShow = 1;
  }

  // Initialize visibleProjects to contain the first 'cardsToShow' indices
  const [visibleProjects, setVisibleProjects] = useState(
    Array.from({ length: cardsToShow }, (_, i) => i)
  );

  const fadeIn = ({ direction, type, delay, duration }) => {
    return {
      hidden: {
        x: direction === "left" ? 100 : direction === "right" ? -100 : 0,
        y: direction === "up" ? 100 : direction === "down" ? -100 : 0,
        opacity: 0,
      },
      show: {
        x: 0,
        y: 0,
        opacity: 1,
        transition: {
          type: type,
          delay: delay,
          duration: duration,
          ease: "easeOut",
        },
      },
    };
  };

  // Calculate the size of the ProjectCard components based on the window size
  const cardWidth = "90%"; // Take up the full width of the container
  const cardHeight = "calc(100% - 40px)"; // Adjust height automatically based on content

  return (
    <>
      <header className="relative">
        <h1>Projects :</h1>
      </header>
      <div
        className="w-full flex flex-col"
        style={{
          height: "calc(100vh - 64px)",
        }}
      >
        <div className="h-full flex flex-wrap content-center justify-center">
          <div className="relative flex flex-row h-5/6 w-full justify-between content-baseline">
            <button className="" disabled={visibleProjects[0] === 0}>
              <img
                className={
                  "max-w-12" +
                  (visibleProjects.includes(0) ? " opacity-40" : "")
                }
                src={backwardArrow}
                alt="previous"
                onClick={() => {
                  setVisibleProjects(visibleProjects.map((index) => index - 1));
                }}
              />
            </button>
            <div className="flex overflow-visible">
              {projectsData.map((project, index) =>
                visibleProjects.includes(index) ? (
                  <Tilt
                    className={`h-full`}
                    key={index}
                    style={{
                      width: `calc(${100 / cardsToShow}%)`,
                    }}
                  >
                    <motion.div
                      variants={fadeIn(fadeInParams)}
                      className="h-full green-pink-gradient rounded-[20px] shadow-card overflow-visible proj-card"
                    >
                      <div
                        options={{
                          max: 45,
                          scale: 1,
                          speed: 450,
                        }}
                        style={{
                          height:
                            cardsToShow < 4 ? "100%" : "calc(100% - 20px)",
                        }}
                        className="bg-tertiary rounded-[20px] flex justify-evenly items-center flex-col overflow-visible"
                      >
                        <ProjectCard
                          style={{ width: cardWidth, height: cardHeight }}
                          title={project.title}
                          technologies={project.technologies}
                          description={project.description}
                          image={project.image}
                          link={project.link}
                        />
                      </div>
                    </motion.div>
                  </Tilt>
                ) : null
              )}
            </div>
            <button
              className=""
              disabled={
                visibleProjects[visibleProjects.length - 1] ===
                projectsData.length - 1
              }
            >
              <img
                className={
                  "max-w-12" +
                  (visibleProjects.includes(
                    Math.max(...projectsData.map((_, i) => i))
                  )
                    ? " opacity-40"
                    : "")
                }
                src={forwardArrow}
                alt="next"
                onClick={() => {
                  setVisibleProjects(visibleProjects.map((index) => index + 1));
                }}
              />
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Projects;
